import Layout from "../include/layout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { useForm } from "react-hook-form";
// importation de la bibliothèque joi 
import Joi from "joi-browser";
import Select from 'react-select';
// date format
import moment from "moment";
import ClassesService from "../classe/ClassesService";
import { useSelector } from "react-redux";
import ClassesoptionsService from "../classesoptions/ClassesoptionsService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PaysService from "../pays/PaysService";
import GenresService from "../genres/GenresService";
import InscriptionsService from "./InscriptionsService";
import FilArial from "../include/filarial";
import { TabView, TabPanel } from 'primereact/tabview';
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import Apprenant from "./apprenantEntite"
import InscriptionForm from "./inscriptionForm"
import ReinscriptionForm from "./ReinscriptionForm";

export default function InscriptionCreate(props) {
    const activeLink = "INSCRIPTION - REINSCRIPTION"
    // get token
    const token = useSelector(state => state.auth.token)

    const [errors, setErrors] = useState({});
    const [errorsParent, setErrorsParent] = useState({});
    const location = useLocation()
    const defaultIndex = location.state?.parametre
 
    const [clicked, setClicked] = useState(false);

    const handleClick = () => {
        setClicked(!clicked);
    };

    const schemaStoreParent = {
        nom: Joi.string().min(2).max(100).required("").options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("Nom"),

        prenoms: Joi.string().min(2).max(200).required().options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 200" },
            },
        }).label("Prénom"),

        email: Joi.string().min(2).max(200).required().options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 200" },
            },
        }).label("Email"),

        telephone: Joi.string().min(8).max(12).required().options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 8 caractères", max: "maximum 12" },
            },
        }).label("Téléphone"),

        genre_id: Joi.number().required().options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("Genre"),

        pays_id: Joi.number().required().options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("Pays/Nationalité"),

        civilite_id: Joi.number().required().options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("Parent"),

        nbre_enfant: Joi.number().required("").options({
            language: {
                any: { required: 'le champ est obligatoire' }
            },
        }).label("Nbre enfant"),

        anneeacademiqueId: Joi.number().required("").empty('').options({
            language: {
              any: { required: 'le champ est obligatoire' },
            },
          }).label("Année Academique"),

    };

    // initialisation des variables
    const [inscriptionApprenantForm, setInscriptionApprenantForm] = useState({
        nom: '',
        prenoms: '',
        telephone: '',
        genre_id: '',
        date_naissance: '',
        lieu_naissance: '',
        classe_id: '',
        classe_option_id: '',
        type_inscription_id: '',
        pays_id: '',
        anneeacademiqueId:''
    });

    const [storeParent, setStoreParent] = useState({
        nom: '',
        prenoms: '',
        telephone: '',
        genre_id: '',
        civilite_id: '',
        nbre_enfant: 0,
        pays_id: '',
        email: ''
    });

    const [classes, setClasses] = useState([])
    const [selectedClasse, setSelectedClasse] = useState(null)
    const [classeoptions, setClasseOptions] = useState([])
    const [selectedClasseOption, setSelectedClasseOption] = useState(null)
    const [pays, setPays] = useState([])
    const [selectedPays, setSelectedPays] = useState(null)
    const [genres, setGenres] = useState([])
    const [selectedGenre, setSelectedGenre] = useState(null)
    const [parents, setParents] = useState([])
    const [selectedParent, setSelectedParent] = useState(null)
    const [civilites, setCivilites] = useState([])
    const [selectedCivilite, setSelectedCivilite] = useState(null)
    const [selectedPaysParent, setSelectedPaysParent] = useState(null)
    const [selectedGenreParent, setSelectedGenreParent] = useState(null)

    //Afficher le modal 
    const [showModalParent, setShowModalParent] = useState(false);
    const handleClose = () => setShowModalParent(false);
    const handleShow = () => setShowModalParent(true);

    const categories = [
        { name: 'Frais Inscription (2.000)', key: 'A' },
        { name: 'Frais TD (10.000)', key: 'M' },
        { name: 'Frais Cantine (12.000)', key: 'P' },
        { name: 'Frais Bulletin (3.000)', key: 'R' }
    ];
    const [selectedCategories, setSelectedCategories] = useState([categories[1]]);

    const onCategoryChange = (e) => {
        let _selectedCategories = [...selectedCategories];

        if (e.checked)
            _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(category => category.key !== e.value.key);

        setSelectedCategories(_selectedCategories);
    };

    

    const saveParent = async () => {
        const formData = new FormData()
        formData.append("nom", storeParent.nom)
        formData.append("prenoms", storeParent.prenoms)
        formData.append("email", storeParent.email)
        formData.append("nombreenfantsParent", storeParent.nbre_enfant)
        formData.append("civiliteId", storeParent.civilite_id)
        formData.append("paysId", storeParent.pays_id)
        formData.append("telephone", storeParent.telephone)
        // persist data
        await InscriptionsService.createParent(formData, token).then((res) => {
            // console.log(res.data.data)
            if (res.data.status === 200) {
                // close modal parent
                handleClose()
                // reset form
                let _data = { ...storeParent };

                _data['nom'] = '';
                _data['prenoms'] = '';
                _data['telephone'] = '';
                _data['email'] = '';
                _data['nbre_enfant'] = '';
                _data['civilite_id'] = '';
                _data['pays_id'] = '';
                setStoreParent(_data);
                fetchParents()
                return true;
            } else {
                return false;
            }
        }).catch(error => {
            console.log(error)
        })
    }

    const validateFormParent = (event) => {
        event.preventDefault();
        const result = Joi.validate(storeParent,
            schemaStoreParent, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (!error) {
            // enregistrement des données
            console.log(storeParent)
            const save = saveParent()
            return save;
        } else {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrorsParent(errorData);
            return errorData;
        }
    };

    const handleSave = (event) => {
        const { name, value } = event.target;
        let errorData = { ...errors };
        const errorMessage = null; // validateProperty(event);
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            delete errorData[name];
        }
        let _data = { ...inscriptionApprenantForm };
        _data[name] = value;
        setInscriptionApprenantForm(_data);
        setErrors(errorData);
    };

    const handleSaveParent = (event) => {
        const { name, value } = event.target;
        let errorData = { ...errorsParent };
        const errorMessage = validatePropertyParent(event);
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            delete errorData[name];
        }
        let _data = { ...storeParent };
        _data[name] = value;
        setStoreParent(_data);
        setErrorsParent(errorData);
    };
 

    const validatePropertyParent = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaStoreParent[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    // mise à jour automatique de l'objet input projet via le formulaire
    /*const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _data = { ...inscriptionApprenantForm };

        _data[`${name}`] = val;

        setInscriptionApprenantForm(_data);
    };*/

    // récupéré la liste des classes
    const fecthClasse = async () => {
        await ClassesService.index(token).then(({ data }) => {
            if (data.data.classes.length > 0) {
                const optionClasse = data.data.map((option, index) => {
                    //console.log(option.libelleClasse)
                    return ({ label: option.libelleClasse, value: option.id })
                })
                setClasses(optionClasse)
            }

        }).catch(({ response }) => {
            console.log("erreur => " + response)
        })
    }

    // gestion changement classe
    const onChangeClasse = (e) => {
        // gestion message d'erreur
        /*let errorData = { ...errors };
        const errorMessage = validateProperty(e);
        if (errorMessage) {
            errorData['classe_id'] = errorMessage;
        } else {
            delete errorData['classe_id'];
        }*/

        let _data = { ...inscriptionApprenantForm };
        _data['classe_id'] = e.value;
        setInscriptionApprenantForm(_data);
        setSelectedClasse(e);
        // récupérer la liste des classes options selon le choix de la classe 
        fetchClassesoptions(e.value)
        setSelectedClasseOption(null)
        _data['classe_option_id'] = '';
        //console.log(classeoptions)
    };

    // gestion changement classe option
    const onChangeClasseOption = (e) => {
        let _data = { ...inscriptionApprenantForm };
        _data['classe_option_id'] = e.value;
        setInscriptionApprenantForm(_data);
        setSelectedClasseOption(e);
        console.log(inscriptionApprenantForm)

    };

    // liste classe option
    //get liste classesoptions
    const fetchClassesoptions = async (id) => {
        await ClassesoptionsService.getOptionByClasse(id, token).then((res) => {
            //console.log(res.data.data)
            if (res.data.data.length > 0) {
                const options = res.data.data.map((options, index) => {
                    return { value: options.id, label: options.libelleClasseOption }
                })
                setClasseOptions(options)
            }
        }).catch(error => {
            console.log(error)
        })
    }

    //get liste pays
    const fetchPays = async (id) => {
        await PaysService.index(token).then((res) => {
            //console.log(res.data.data)
            if (res.data.data.length > 0) {
                const options = res.data.data.map((options, index) => {
                    return { value: options.id, label: options.nompaysPays + '/' + options.nationalitePays }
                })
                setPays(options)
            }
        }).catch(error => {
            console.log(error)
        })
    }
    // update pays selected
    // gestion changement classe option
    const onChangePays = (e, type) => {
        if (type === "parent") {
            let _data = { ...storeParent };
            _data['pays_id'] = e.value;
            setStoreParent(_data);
            setSelectedPaysParent(e);
        } else {
            let _data = { ...inscriptionApprenantForm };
            _data['pays_id'] = e.value;
            setInscriptionApprenantForm(_data);
            setSelectedPays(e);

        }
    };


    //get liste genre
    const fetchGenres = async (id) => {
        await GenresService.index(token).then((res) => {
            //console.log(res.data.data)
            if (res.data.data.length > 0) {
                const options = res.data.data.map((options, index) => {
                    return { value: options.id, label: options.libelleGenre }
                })
                setGenres(options)
            }
        }).catch(error => {
            console.log(error)
        })
    }

    // update genre
    const onChangeGenre = (e, type) => {
        if (type === "parent") {
            let _data = { ...storeParent };
            _data['genre_id'] = e.value;
            setStoreParent(_data);
            setSelectedGenreParent(e);
        } else {
            let _data = { ...inscriptionApprenantForm };
            _data['genre_id'] = e.value;
            setInscriptionApprenantForm(_data);
            setSelectedGenre(e);
        }

    };

    //get liste parent
    const fetchParents = async (id) => {
        await InscriptionsService.getParents(token).then((res) => {

            if (res.data.data.length > 0) {
                const options = res.data.data.map((options, index) => {
                    //console.log(options.personnes.nomPersonne)
                    return { value: options.id, label: options.personnes.nomPersonne + " " + options.personnes.prenomsPersonne }
                })
                setParents(options)
                console.log(parents)
            }
        }).catch(error => {
            console.log(error)
        })
    };
    // update parent selected 
    const onChangeParent = (e) => {
        let _data = { ...inscriptionApprenantForm };
        _data['parent_id'] = e.value;
        setInscriptionApprenantForm(_data);
        setSelectedParent(e);
    };

    //get liste civilite
    const fetchCivilites = async (id) => {
        await InscriptionsService.getCivilites(token).then((res) => {
            // console.log(res.data.data)
            if (res.data.data.length > 0) {
                const options = res.data.data.map((options, index) => {
                    return { value: options.id, label: options.libelleCivilite }
                })
                setCivilites(options)
            }
        }).catch(error => {
            console.log(error)
        })
    };

    // update civilite selected 
    const onChangeCivilite = (e) => {
        let _data = { ...storeParent };
        _data['civilite_id'] = e.value;
        setStoreParent(_data);
        setSelectedCivilite(e);
    };

    const [studentData, setStudentData] = useState(null);
    const [studentReinscriptionData, setStudentReinscriptionData] = useState(null);

    
    const handleCreateStudent = (formData) => {
        // Créez une nouvelle instance de la classe Student avec les données du formulaire
        const newStudent = new Apprenant(
          null, // L'identifiant peut être null pour un nouvel étudiant
          formData.nom,
          formData.prenom,
          formData.telephone, 
        );
        console.log(newStudent)
        // Appeler l'API pour créer un nouvel étudiant en utilisant l'objet newStudent
    
        // Après la création réussie, vous pouvez mettre à jour l'état ou effectuer d'autres actions nécessaires
        // Par exemple, si l'API renvoie un nouvel objet étudiant avec un identifiant généré, vous pouvez le définir dans l'état local.
        // setStudentData(nouvelEtudiant);
      };

    useEffect(() => {
        fecthClasse()
        fetchPays()
        fetchGenres()
        fetchParents()
        fetchCivilites()
    }, []);

    return (
        <Layout>

            <div className="container-xxl flex-grow-1 container-p-y">

                <FilArial activeLink={activeLink} />
                <div className="row mb-4 mt-3">
                    {/* Step form */}

                    <div className="card shadow-lg ">
                        <TabView activeIndex={defaultIndex}>
                            <TabPanel header="&nbsp; INSCRIPTION" className="customTabPanel" style={{ width: "100%" }} leftIcon="pi pi-user ml-2">
                                <div className="m-0"> 
                                <InscriptionForm apprenant={studentData}/>
                                </div>
                            </TabPanel>
                            <TabPanel header="&nbsp; REINSCRIPTION" headerStyle={{ alignContent: "" }} style={{ width: "100%", textAlign: "" }} leftIcon="pi pi-user">
                                <div className="m-0">
                                <ReinscriptionForm apprenant={studentReinscriptionData}/>
                                </div>
                            </TabPanel>
                        </TabView>
                    </div>

                    {/* end Step form */}


                    <Modal show={showModalParent} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className="text-white">Enregistrement Parent</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form
                                className="needs-validation"
                                noValidate
                            >
                                {/********** modal body ***********/}
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <Form.Label className="form-label" htmlFor="bs-validation-nom">Nom <i className="text-danger">*</i></Form.Label>
                                        <Form.Control className="form-control" name="nom" type="text" value={storeParent.nom} onChange={handleSaveParent}
                                            placeholder="" required={true} maxLength={100} minLength={3} />

                                        <div className="">
                                            {errorsParent.nom && (
                                                <div className="alert alert-danger">
                                                    {errorsParent.nom}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <Form.Label className="form-label" htmlFor="bs-validation-nom">Prénoms <i className="text-danger">*</i></Form.Label>
                                        <Form.Control className="form-control" name="prenoms" id="" type="text" value={storeParent.prenoms} onChange={handleSaveParent}
                                            placeholder="" />
                                        <div className="">
                                            {errorsParent.prenoms && (
                                                <div className="alert alert-danger">
                                                    {errorsParent.prenoms}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <Form.Label className="form-label" htmlFor="bs-validation-nom">Téléphone <i className="text-danger">*</i></Form.Label>
                                        <Form.Control className="form-control" type="text" value={storeParent.telephone} onChange={handleSaveParent}
                                            placeholder="" name="telephone" />
                                        <div className="">
                                            {errorsParent.telephone && (
                                                <div className="alert alert-danger">
                                                    {errorsParent.telephone}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <Form.Label className="form-label" htmlFor="bs-validation-nom">E-mail <i className="text-danger">*</i></Form.Label>
                                        <Form.Control className="form-control" type="email" value={storeParent.email} onChange={handleSaveParent}
                                            placeholder="" name="email" />
                                        <div className="">
                                            {errorsParent.email && (
                                                <div className="alert alert-danger">
                                                    {errorsParent.email}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">

                                    <div className="col-md-6 mb-3">
                                        <Form.Label className="form-label" htmlFor="bs-validation-nom">Genre <i className="text-danger">*</i></Form.Label>
                                        <Select
                                            options={genres}
                                            onChange={(e) => onChangeGenre(e, 'parent')}
                                            value={selectedGenreParent}
                                            required
                                            name="genre_id"
                                        />
                                        <div className="">
                                            {errorsParent.genre_id && (
                                                <div className="alert alert-danger">
                                                    {errorsParent.genre_id}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <Form.Label className="form-label" htmlFor="bs-validation-roles_options">Pays/Nationalité <i className="text-danger">*</i></Form.Label>
                                        <Select
                                            options={pays}
                                            onChange={(e) => onChangePays(e, 'parent')}
                                            value={selectedPaysParent}
                                            required
                                            name="pays_id"
                                        />
                                        <div className="">
                                            {errorsParent.pays_id && (
                                                <div className="alert alert-danger">
                                                    {errorsParent.pays_id}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <Form.Label className="form-label" htmlFor="bs-validation-roles_options">Civilité <i className="text-danger">*</i></Form.Label>
                                        <Select
                                            options={civilites}
                                            onChange={(e) => onChangeCivilite(e)}
                                            value={selectedCivilite}
                                            required
                                            name="civilite_id"
                                        />
                                        <div className="">
                                            {errorsParent.civilite_id && (
                                                <div className="alert alert-danger">
                                                    {errorsParent.civilite_id}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <Form.Label className="form-label" htmlFor="bs-validation-nom">Nbre enfant <i className="text-danger">*</i></Form.Label>
                                        <Form.Control className="form-control" name="nbre_enfant" id="nbre_enfant" type="text" value={storeParent.nbre_enfant} onChange={handleSaveParent}
                                            placeholder="" />
                                        <div className="">
                                            {errorsParent.nbre_enfant && (
                                                <div className="alert alert-danger">
                                                    {errorsParent.nbre_enfant}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        Fermer
                                    </Button>
                                    <Button variant="primary" type="submit" onClick={validateFormParent}>
                                        Enregistrer
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal.Body>
                    </Modal>

                </div>

            </div>

        </Layout>
    )
}